import { render, staticRenderFns } from "./DimensionsBlock.vue?vue&type=template&id=0b581345&scoped=true"
import script from "./DimensionsBlock.vue?vue&type=script&lang=js"
export * from "./DimensionsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b581345",
  null
  
)

export default component.exports